import { BP42InitialState } from '@r1-frontend/bp42/reducer/initialState';

const getIsLoading = (state: BP42InitialState): boolean => state._loading;

export default getIsLoading;
